/* SK Shipping Cost — coste de envio REAL desde la Shipping Rates API de Shopify.
   Tarifa "por importe del pedido" => depende del subtotal del carrito de la sesion.
   Destino asumido: Peninsula (Madrid 28001).
   - Rellena la fila "Envío" con la tarifa del tramo (o GRATIS).
   - En GRATIS por importe, tacha la tarifa MAS ALTA vista de la API (ej 9,39€).
   - Cupon de portes gratis: la API de tarifas NO aplica descuentos (Shopify solo los aplica
     en el checkout) y Liquid tampoco los ve — cart.discount_applications solo lista los que
     asignan importe a algo del carrito, y el carrito no tiene linea de envio. La unica senal
     disponible es /cart.js: un codigo applicable que no descuenta NADA del carrito solo puede
     estar descontando el envio. Con eso pintamos GRATIS y tachamos la tarifa real.
   - Suma el envio al total del boton "pagar".
   - sessionStorage para pintar al instante en recargas/cambios (sin flash del fallback). */
(function () {
  'use strict';
  if (window.__skShippingCostInit) return;
  window.__skShippingCostInit = true;

  var ADDR = 'shipping_address%5Bcountry%5D=Spain&shipping_address%5Bprovince%5D=Madrid&shipping_address%5Bzip%5D=28001';
  var K_SHIP = 'sk_ship_v';       /* ultima tarifa BRUTA: "6.10" | "FREE" */
  var K_MAX = 'sk_ship_max';      /* tarifa mas alta vista: "9.39" */
  var K_CUPON = 'sk_ship_cupon';  /* "1" si hay cupon de portes */

  function lsGet(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  function euroSuffix(p) { return parseFloat(p).toFixed(2).replace('.', ',') + '€'; }            /* 6,10€ */
  function euroPrefix(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, ''); } /* €141,10 / €135 */

  /* --- Deteccion del cupon de portes ---------------------------------------
     Un codigo puede descontar productos, el pedido o el envio. Si esta aceptado
     (applicable) pero no ha asignado ni un centimo dentro del carrito, lo que
     descuenta es el envio. Limitacion conocida: un codigo que descuente producto
     Y envio a la vez no se detecta (asigna importe, asi que cae del lado producto). */
  function esCuponDePortes(c) {
    if (!c) return false;
    var codes = c.discount_codes || [], aceptados = 0;
    for (var i = 0; i < codes.length; i++) { if (codes[i].applicable) aceptados++; }
    if (!aceptados) return false;
    if ((c.total_discount || 0) > 0) return false;
    if ((c.cart_level_discount_applications || []).length > 0) return false;
    return true;
  }

  function cuponDePortes() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(esCuponDePortes)
      .catch(function () { return false; });
  }

  /* Los scripts del carrito nos pasan el carrito recien actualizado en cuanto lo cambian.
     Asi, cuando el re-render de la seccion vuelve a poner el placeholder "…", ya podemos
     pintar el valor correcto al instante en vez de esperar otra vuelta a /cart.js. */
  window.skShippingCoupon = {
    set: function (cart) { lsSet(K_CUPON, esCuponDePortes(cart) ? '1' : '0'); }
  };

  function paintShipping(el, ship, maxRef, gratisPorCupon) {
    if (gratisPorCupon || ship === 'FREE') {
      /* Con cupon sabemos la tarifa real de este carrito y la tachamos; con el envio gratis
         por importe la API devuelve 0, asi que tachamos la mas alta vista. */
      var ref;
      if (gratisPorCupon && ship !== 'FREE' && ship !== null) ref = euroSuffix(ship);
      else ref = maxRef ? euroSuffix(maxRef) : (el.getAttribute('data-reference') || '8,00€');
      el.innerHTML = '<s class="' + (el.getAttribute('data-strike-class') || '') + '">' + ref + '</s> GRATIS';
    } else {
      el.textContent = euroSuffix(ship);
    }
  }
  function paintButton(btn, ship, gratisPorCupon) {
    var base = parseInt(btn.getAttribute('data-cart-total'), 10);
    if (isNaN(base)) return;
    var shipCents = (gratisPorCupon || ship === 'FREE') ? 0 : Math.round(parseFloat(ship) * 100);
    btn.textContent = (btn.getAttribute('data-pay-label') || 'pagar') + ' · ' + euroPrefix(base + shipCents);
  }

  /* Barra de envio gratis: con cupon de portes el progreso hacia el minimo sobra */
  var MSG_CUPON = '¡Envío gratis aplicado con tu cupón!';
  function paintBar(gratisPorCupon) {
    var bars = document.querySelectorAll('.sk-cdrf__shipping-bar, .sk-cart__shipping-bar');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var msg = bar.querySelector('.sk-cdrf__shipping-msg, .sk-cart__shipping-msg');
      if (!msg) continue;
      var mod = (bar.className.indexOf('sk-cdrf__') !== -1) ? 'sk-cdrf__shipping-bar--coupon' : 'sk-cart__shipping-bar--coupon';
      if (gratisPorCupon) {
        if (!msg.hasAttribute('data-msg-original')) msg.setAttribute('data-msg-original', msg.textContent);
        if (msg.textContent !== MSG_CUPON) msg.textContent = MSG_CUPON;
        bar.classList.add(mod);
      } else {
        var orig = msg.getAttribute('data-msg-original');
        if (orig !== null) { msg.textContent = orig; msg.removeAttribute('data-msg-original'); }
        bar.classList.remove(mod);
      }
    }
  }

  /* Valor cacheado al instante (una vez por elemento) para que no se vea el fallback */
  function paintCached(ship, maxRef, cupon) {
    paintBar(cupon);
    if (ship === null) return;
    var s = document.querySelectorAll('[data-shipping-cost]:not([data-shipping-cached])');
    for (var i = 0; i < s.length; i++) { s[i].setAttribute('data-shipping-cached', '1'); paintShipping(s[i], ship, maxRef, cupon); }
    var b = document.querySelectorAll('[data-checkout-total]:not([data-shipping-cached])');
    for (var k = 0; k < b.length; k++) { b[k].setAttribute('data-shipping-cached', '1'); paintButton(b[k], ship, cupon); }
  }
  /* Valor real (tras la API) y marca done */
  function paintReal(ship, maxRef, cupon) {
    paintBar(cupon);
    var s = document.querySelectorAll('[data-shipping-cost]');
    for (var i = 0; i < s.length; i++) { paintShipping(s[i], ship, maxRef, cupon); s[i].setAttribute('data-shipping-done', '1'); }
    var b = document.querySelectorAll('[data-checkout-total]');
    for (var k = 0; k < b.length; k++) { paintButton(b[k], ship, cupon); }
  }

  var running = false, dirty = false;
  function run() {
    if (!document.querySelector('[data-shipping-cost]:not([data-shipping-done])')) return;
    var cachedMax = lsGet(K_MAX);
    /* Pintado instantaneo: la tarifa y el estado del cupon salen de la cache, que los
       scripts del carrito mantienen al dia via skShippingCoupon.set(). Sin esto la fila se
       quedaba en el placeholder "…" hasta que respondiese /cart.js. */
    paintCached(lsGet(K_SHIP), cachedMax, lsGet(K_CUPON) === '1');
    if (running) { dirty = true; return; }
    running = true; dirty = false;
    Promise.all([fetchRates(), cuponDePortes()]).then(function (res) {
      running = false;
      var rates = res[0], cupon = res[1];
      lsSet(K_CUPON, cupon ? '1' : '0');
      if (rates === null) {
        /* API fallo: dejar lo cacheado o la referencia; nunca inventar GRATIS
           (salvo cupon de portes, que el checkout va a aplicar igual) */
        var pend = document.querySelectorAll('[data-shipping-cost]:not([data-shipping-done])');
        for (var i = 0; i < pend.length; i++) {
          if (cupon) paintShipping(pend[i], 'FREE', cachedMax, true);
          else if (!pend[i].hasAttribute('data-shipping-cached')) pend[i].textContent = pend[i].getAttribute('data-reference') || '8,00€';
          pend[i].setAttribute('data-shipping-done', '1');
        }
        paintBar(cupon);
        if (dirty) run();
        return;
      }
      var ship, max = cachedMax ? parseFloat(cachedMax) : 0;
      if (rates.length === 0) {
        ship = 'FREE';
      } else {
        var ch = rates.reduce(function (a, b) { return parseFloat(a.price) <= parseFloat(b.price) ? a : b; });
        ship = (parseFloat(ch.price) === 0) ? 'FREE' : ch.price;
        for (var r = 0; r < rates.length; r++) { var pr = parseFloat(rates[r].price); if (pr > max) max = pr; }
      }
      if (max > 0) { cachedMax = max.toFixed(2); lsSet(K_MAX, cachedMax); }
      lsSet(K_SHIP, ship);
      paintReal(ship, cachedMax, cupon);
      if (dirty) run();
    });
  }

  function retry(a) { return new Promise(function (r) { setTimeout(r, 800); }).then(function () { return poll(a + 1); }); }
  function poll(a) {
    if (a >= 6) return Promise.resolve(null);
    return fetch('/cart/async_shipping_rates.json?' + ADDR)
      .then(function (res) {
        if (!res.ok) return retry(a);
        return res.json().then(function (j) { return (j && j.shipping_rates) ? j.shipping_rates : retry(a); });
      })
      .catch(function () { return retry(a); });
  }
  function fetchRates() {
    return fetch('/cart/prepare_shipping_rates.json?' + ADDR, { method: 'POST' })
      .then(function () { return poll(0); })
      .catch(function () { return null; });
  }

  var t = null;
  function schedule() {
    /* El pintado desde cache es gratis: hacerlo YA. Si esperaba al debounce, tras cada
       re-render de la seccion la fila se quedaba 250ms con el placeholder "…" y parecia
       que el carrito cargaba dos veces. El fetch de tarifas, que si es caro, sigue con debounce. */
    if (document.querySelector('[data-shipping-cost]:not([data-shipping-cached])')) {
      paintCached(lsGet(K_SHIP), lsGet(K_MAX), lsGet(K_CUPON) === '1');
    }
    if (t) clearTimeout(t);
    t = setTimeout(run, 250);
  }
  function init() { run(); new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
